<template>
  <div>
    <div v-if="postList !== null">
      <div class="row">
        <div class="col-md-12">
          <h4 style="margin-top:5px; margin-left:10px;">Campaign Content</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div>
            <p-button outline type="info" size="sm" round @click="$router.go(-1)">
              <i class="fa fa-chevron-circle-left"></i>
              Back
            </p-button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="btn-group">
            <p-button type="info" @click="filterList('feed')" round outline>FEED</p-button>

            <p-button type="info" @click="filterList('story')" round outline>STORY</p-button>
          </div>
        </div>
        <div class="col-md-4">
          <div style="padding:10px; float:right; width: 300px;">
            <select v-model="listView" class="custom-select" @change="sortPostList">
              <option value selected>sort by:</option>
              <option
                v-for="option in ['newest','oldest', 'most likes','most comments']"
                :value="option"
                :key="option"
              >{{ option }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="row">
          <div class="col-md-12">
            <div
              style="width:250px; float: left;"
              v-for="post in visibleList"
              :key="post.shortcode"
            >
              <div
                class="hovereffect"
                style="cursor: pointer; width: 250px;"
                @click="$router.push(`/instagram/post/`+ post.shortcode)"
              >
                <div class="post-item">
                  <img
                    :src="post.imageUrlCache"
                    v-if="typeof post.imageUrlCache !=='undefined'"
                    width="250"
                  />
                  <img
                    :src="post.imageUrl"
                    @error="imageLoadCache(post.shortcode)"
                    width="250"
                    v-else
                  />

                  <div class="overlay">
                    <div class="overlay-stats">
                      <div style="padding:15px;">
                        <i v-if="post.mediaType=='carousel'" class="fas fa-photo-video"></i>
                        <i v-if="post.mediaType=='image'" class="far fa-image"></i>
                        <i v-if="post.mediaType=='video'" class="fas fa-video"></i>
                      </div>
                      <p v-if="post.mediaType=='video'">views: {{post.viewCountString}}</p>
                      <p>likes: {{post.likeCountString}}</p>
                      <p>comments: {{post.commentCountString}}</p>

                      <p class="icon-links">
                        <p-button type="info" round>View Post</p-button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="lds-dual-ring"></div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import _ from "underscore";
import {
  influencerCampaignReadApi,
  influencerCollaborationDetailApi,
  influencerCollabPostSearchApi,
  userLoadApi,
  instagramPostCacheApi
} from "@/config/appSettings";
import IgProfile from "@/libs/ig/profileData";
import { mapGetters, mapActions } from "vuex";
import store from "@/store/index.js";
export default {
  data: () => ({
    auth: null,
    loadingOverlay: false,
    campaign: null,
    postList: null,
    visibleList: [],
    currentInstagram: null,
    campaigns: null,
    isInfluencer: null,
    isClient: null,
    listView: "newest"
  }),
  name: "InfluencerPostSearch",
  methods: {
    async imageLoadCache(shortcode) {
      let postCacheUrl = `${instagramPostCacheApi}/?usertoken=${this.auth}&shortcode=${shortcode}`;
      let postCacheResponse = await axios.get(postCacheUrl);
      console.log(`LOADING ${shortcode}`, postCacheResponse.data);
    },

    async sortPostList() {
      try {
        //console.log("LIST VIEW CHANGE:", this.listView);
        //console.log("LIST AVAILABLE:", this.candidatesAll);

        if (this.listView == "newest") {
          this.visibleList = _.sortBy(this.postList, "dateAdded").reverse();
          if (typeof this.$route.query.sort !== "undefined") {
            this.$router.push(
              `/influencer-campaign/post/search/${this.$route.params.campaignId}`
            );
          }
        }
        if (this.listView == "oldest") {
          this.visibleList = _.sortBy(this.postList, "dateAdded");

          if (typeof this.$route.query.sort !== "oldest") {
            this.$router.push(
              `/influencer-campaign/post/search/${this.$route.params.campaignId}/?sort=oldest`
            );
          }
        }
        if (this.listView == "most likes") {
          this.visibleList = _.sortBy(this.postList, "likeCount").reverse();
          //console.log("LIKE SORTED:", this.visibleList);
          if (typeof this.$route.query.sort !== "likes") {
            this.$router.push(
              `/influencer-campaign/post/search/${this.$route.params.campaignId}/?sort=likes`
            );
          }
        }
        if (this.listView == "most comments") {
          this.visibleList = _.sortBy(this.postList, "commentCount").reverse();
          //console.log("COMMENT SORTED:", this.visibleList);
          if (typeof this.$route.query.sort !== "comments") {
            this.$router.push(
              `/influencer-campaign/post/search/${this.$route.params.campaignId}/?sort=comments`
            );
          }
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPosts() {
      try {
        let searchUrl = `${influencerCollabPostSearchApi}/?usertoken=${this.auth}&campaign=${this.$route.params.campaignId}`;
        if (typeof this.$route.query.instagram !== "undefined") {
          searchUrl = `${searchUrl}&instagram=${this.$route.query.instagram}`;
        }
        //console.log("POST URL:", searchUrl)
        let instagramPostResponse = await axios.get(searchUrl);

        //console.log("POST LIST :", instagramPostResponse.data);

        if (instagramPostResponse.data.success === true) {
          //console.log("SETTING POST LIST:");

          this.postList = _.sortBy(
            instagramPostResponse.data.result,
            "dateAdded"
          ).reverse();
          this.postList = this.postList.map(x => {
            let newPostList = JSON.parse(JSON.stringify(x));
            newPostList.likeCount = Number(newPostList.likeCount);
            newPostList.commentCount = Number(newPostList.commentCount);
            newPostList.likeCountString = newPostList.likeCount;
            newPostList.commentCountString = newPostList.commentCount;
            return newPostList;
          });
          //console.log("POST LIST", this.postList);

          this.filterList("feed");
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadIgDirect() {
      let thisProfile = await IgProfile.getProfileDataDirect(
        this.$route.params.instagram
      );

      this.currentInstagram = {
        instagramProfile: thisProfile.result.profileName,
        instagramId: thisProfile.result.id
      };
    },

    async filterList(view) {
      this.visibleList = this.postList.filter(x => {
        return x.postType == view;
      });
    },

    async loadPageContent() {
      //await this.loadCampaignDetails();

      await this.loadPosts();
      this.sortPostList();
    }
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadPageContent();
  },
  created() {
    try {
      if (typeof this.$route.query.sort !== "undefined") {
        if (this.$route.query.sort == "comments") {
          this.listView = "most comments";
        }
        if (this.$route.query.sort == "likes") {
          this.listView = "most likes";
        }
      }
    } catch (err) {
      console.log("THERE WAS AN ERROR:", err);
    }
  },
  computed: {
    ...mapGetters(["profileStore"])
  }
};
</script>

<style scoped>
.post-item {
  float: left;
  padding: 10px;
  height: 250px;
  width: 250px;
  overflow: hidden;
  cursor: pointer !important;
}
.overlay {
  width: 250px;
}
.overlay p {
  color: white;
}
.overlay i {
  font-size: 40px;
  color: white;
}
.overlay-stats {
  margin: 0;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>